<app-header>
  <app-nav class="nav-component"></app-nav>
</app-header>
<main [ngClass]="{ 'banner-overlap': shouldOverlap$ | async }">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
